<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "industry",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "交易规模",
                        data: "shares",
                        unit: "亿元"
                    },
                    {
                        name: "用户规模",
                        data: "a100",
                        unit: "亿人"
                    },
                    {
                        name: "融资事件数量",
                        data: "a129",
                        unit: "次"
                    },
                    {
                        name: "融资金额",
                        data: "a130",
                        unit: "亿元"
                    }
                ],
                name: '社交电商'
            }
        }
    },
    created() {
        this.$store.dispatch('getIndustry', this.params)
    },
}
</script>